import type { Comment } from '@getaccept/lib-shared/src/contextual-comments/types/comment';

export class CommentHelper {
  static getTotalHeight(element: HTMLElement): number {
    const height = element.offsetHeight;
    const marginTop = +element.style.marginTop.replace('px', '');
    return height + marginTop;
  }

  static getMarginToRemoveFromComment(
    commentMargin: number,
    marginToRemove: number,
    minimumMargin: number
  ): number {
    const diff = commentMargin - marginToRemove;
    if (diff >= minimumMargin) {
      return marginToRemove;
    }
    return commentMargin - minimumMargin;
  }

  static getReversedCommentIdsBeforeId(id: string, comments: Comment[]): string[] {
    const index = comments.findIndex((comment: Comment) => comment.id === id);
    return comments
      .map((comment: Comment) => comment.id)
      .slice(0, index)
      .reverse();
  }

  static getCommentIdsAfterSelectedComment(id: string, comments: Comment[]): string[] {
    const index = comments.findIndex((comment: Comment) => comment.id === id);
    return comments.map((comment: Comment) => comment.id).slice(index + 1);
  }

  static evaluateIsIndexFinalComment(index: number, commentsLength: number): boolean {
    return index + 1 === commentsLength;
  }

  static evaluateMarginOptions(actual: number, selection?: number): number {
    if (selection > 0 || selection < 0) {
      return selection;
    }
    return actual;
  }
}
